import React from 'react';
import * as Icons from "react-feather";
import { styles } from './style';
import * as Mui from '@mui/material';
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";

interface Props extends OwnProps,
	WithStyles<typeof styles> {}

interface OwnProps {
	onClose: () => void;
	title: string;	
}

class Component extends React.Component<Props> {

	render() {
		const { classes = {}, title } = this.props;
		return (
			<Mui.DialogTitle className={classes.root}>
				<Mui.Typography variant="h4" component="h2">
					{title}
				</Mui.Typography>
				<Mui.IconButton
					onClick={() => this.props.onClose()}
				>
					<Icons.X />
				</Mui.IconButton>
			</Mui.DialogTitle>
		);
	}
}

export const DialogTitle = withStyles(Component, styles);